import { initShowcase } from './tabs';

function initialize() {
    document.querySelectorAll<HTMLElement>('.stgb-columns-showcase').forEach(initShowcase);
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
else initialize();
